module.exports = __webpack_public_path__ + "img/SDGoals.419e30f0.png";